// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3UQKU","header":"MessagesList_header__A6vM3","chat":"MessagesList_chat__2_1yV"};